"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = exports.Title = exports.TextWrapper = exports.ChildrenWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding-left: 64px;
  padding-right: 64px;
  padding-top: 16px;
  padding-bottom: 32px;
  border: 1px solid ${colors_1.GREY2};
  align-items: center;
  justify-items: center;
  background-color: ${colors_1.WHITE};
  cursor: pointer;
  &:hover {
    border: 1px solid ${colors_1.SWEGON_GREEN};
  }
  @media screen and (max-width: 688px) {
    grid-template-rows: auto;
    grid-template-columns: auto auto;
    box-sizing: border-box;
    padding: 16px;
    column-gap: 16px;
    justify-items: start;
  }
`;
exports.ChildrenWrapper = styled_components_1.default.div ``;
exports.TextWrapper = styled_components_1.default.div `
  display: grid;
  grid-column-start: 2;
  grid-row-start: 3;
  align-items: center;
  justify-items: center;
  @media screen and (max-width: 688px) {
    grid-column-start: 2;
    grid-row-start: 1;
  }
`;
exports.Title = styled_components_1.default.label `
  color: ${colors_1.GREY4};
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
`;
exports.Description = styled_components_1.default.label `
  color: ${colors_1.GREY4};
  cursor: pointer;
  margin-top: 8px;
  font-size: 14px;
`;
//# sourceMappingURL=ProductCard.styles.js.map